import React from 'react';
import { useEventManagement } from './useEventManagement';
import EventListAndDetail from './EventListAndDetail';
import EventFormModal from './EventFormModal';
import EventModals from './EventModals';

export const EventManagementPanel: React.FC = () => {
  const model = useEventManagement();
  return (
    <div>
      <EventListAndDetail model={model} />
      <EventFormModal model={model} />
      <EventModals model={model} />
    </div>
  );
};
